export default __webpack_public_path__ + "static/headstand-onelegup-3-759ccc1967b66a28883df3e040c86089.jpg";